export enum NoticePeriodEnum {
  ASAP,
  ONE_WEEK,
  TWO_WEEKS,
  THREE_WEEKS,
  ONE_MONTH,
  TWO_MONTHS,
  THREE_MONTHS,
  HALF_YEAR,
  YEAR
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/notice-period.enum.ts